import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import List from './List';
import New from './New';
import Details from './Details';
import TemplateBuilder from './TemplateBuilder';
import TemplateViewer from './TemplateViewer';

const LexipolAdminRoutes: React.FC = () => (
  <Routes>
    <Route
      index
      element={<List />}
    />
    <Route
      path='new'
      element={<New />}
    />
    <Route
      path='details/:id/*'
      element={<Details />}
    />
    <Route
      path='builder/:id'
      element={<TemplateBuilder />}
    />
    <Route
      path='view/:id'
      element={<TemplateViewer />}
    />
    <Route
      path='*'
      element={
        <Navigate
          to=''
          replace
        />
      }
    />
  </Routes>
);

export default LexipolAdminRoutes;

